import { PreviewDialog } from "./preview-dialog";
import { BrandingPreviewValues } from "./types";
import { WebLoginPreview } from "./web-login-preview";

// Size the login preview is laid out at before it is scaled to fit
const PREVIEW_WIDTH = 1168;
const PREVIEW_HEIGHT = 584;

type WebAppDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  previewValues: BrandingPreviewValues;
};

export function WebAppDialog({
  open,
  onOpenChange,
  previewValues,
}: WebAppDialogProps) {
  return (
    <PreviewDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Web app"
      description="How your brand appears to clients on the web app login"
      width={PREVIEW_WIDTH}
      height={PREVIEW_HEIGHT}
      // Wider and shorter than the default, to suit the landscape preview
      className="h-[min(calc(100dvh-2rem),660px)] w-[min(calc(100vw-2rem),1080px)]"
    >
      <WebLoginPreview {...previewValues} width={PREVIEW_WIDTH} />
    </PreviewDialog>
  );
}
